// src/pages/item_deliveries/AllotedItemList.js
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import itemDeliveryService from '../../services/itemDeliveryService';
import allotedItemsService from '../../services/allotedItemsService';
import { TbFileInvoice } from 'react-icons/tb';
import { last, split } from 'lodash';

const InwardItemList = () => {
  const [itemDeliveries, setItemDeliveries] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchItemDeliveries = async () => {
      const response = await allotedItemsService.getAllotedItems();
      setItemDeliveries(response.data);
    };
    fetchItemDeliveries();
  }, []);

  const handleDelete = async (id) => {
    await itemDeliveryService.deleteItemDelivery(id);
    setItemDeliveries(
      itemDeliveries.filter((itemDelivery) => itemDelivery.id !== id)
    );
  };

  return (
    <LayoutContainer>
      <AdminHeader title='Inward Item' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/inward-items/new')}
          >
            Add Inward Item
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Item </TableCell>
              <TableCell>Inward Quantity</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Photo</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {itemDeliveries.map((itemDelivery) => (
              <TableRow key={itemDelivery.id}>
                <TableCell>{itemDelivery.item_name}</TableCell>
                <TableCell>{itemDelivery.inward_qty}</TableCell>
                <TableCell>{itemDelivery.location_name}</TableCell>
                <TableCell>
                  {itemDelivery?.photo ? (
                    <Link
                      target='_blank'
                      rel='noopener noreferrer'
                      href={itemDelivery?.photo}
                      sx={{ textDecoration: 'none' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {<TbFileInvoice size={18} />}{' '}
                        {last(split(itemDelivery?.photo, '/'))}
                      </div>
                    </Link>
                  ) : (
                    '-'
                  )}
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() =>
                      navigate(`/inward-items/edit/${itemDelivery.id}`)
                    }
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {/* <IconButton onClick={() => handleDelete(itemDelivery.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default InwardItemList;
